module.exports = __webpack_public_path__ + "media/img/seed/3-4c0ca011cbb189fb4bdbce35e52fa0ac.jpeg";